import Services from './base-services'

const service = new Services('avatarFavorite')
import mapParameters from '../utils/map-parameters'

export default {
    getAllByUser(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get('getAllByUser', params)
    },
    createFavorite(userId: number|string, avatarId: number|string) {
        const params = {
            user: {
                id: userId
            },
            avatar: {
                id: avatarId
            }
        }
        return service.post('createFavorite', params)
    },
    deleteFavorite(userId: number|string, avatarId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null,
            avatarId: avatarId ? avatarId : null
        })
        return service.delete('deleteFavorite', params)
    }
}
